// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_Projects__3_4Kv","otherProjects":"Projects_otherProjects__1m9qx","codeLink":"Projects_codeLink__2BE-Z","content":"Projects_content__2FPu7"};